import { ElectionPageParams } from "@/src/common/types"
import { raceIsRepresentative } from "@/src/common/utils"
import PresidentElectionCtx from "@/src/contexts/PresidentElectionCtx"
import { URL_SLUG_TO_RACE_HASH_MAP } from "@/src/elections/business-layer/constants"
import {
  BaseElectionTemplateProps,
  MapTemplateProps
} from "@/src/elections/business-layer/types"
import { GetElectionPropsUsecase } from "@/src/elections/business-layer/usecases"
import ElectionTemplate from "@/src/elections/components/ElectionTemplate"
import {
  ElectionsAPIInstance,
  ExternalHTTPInstance
} from "@/src/elections/data-layer"
import stateBoundaries from "@/src/elections/data-layer/geojson/state-houses-of-assembly-state-boundaries.json"
import stateHouse from "@/src/elections/data-layer/geojson/state-houses-of-assembly.json"
import { ElectionSources2023 } from "@/src/elections/data-layer/types"
import * as Sentry from "@sentry/nextjs"
import { FeatureCollection } from "geojson"
import type {
  GetServerSidePropsContext,
  GetServerSidePropsResult,
  NextPage
} from "next"
import { useState } from "react"

const RaceSummary: NextPage<BaseElectionTemplateProps> = (
  props: BaseElectionTemplateProps
) => {
  const [electionSource, setElectionSource] = useState(ElectionSources2023.TV)

  const mapProps = {
    ...props.mapProps,
    appendStateName: true,
    stateBoundaries: stateBoundaries as FeatureCollection,
    mapFeatures: stateHouse as FeatureCollection
  } as MapTemplateProps

  return (
    <PresidentElectionCtx.Provider
      value={{ source: electionSource, setSource: setElectionSource }}
    >
      <ElectionTemplate
        templateProps={{ ...props, mapProps }}
        electionsAPI={ElectionsAPIInstance}
        externalHTTP={ExternalHTTPInstance}
      />
    </PresidentElectionCtx.Provider>
  )
}

export async function getServerSideProps(
  context: GetServerSidePropsContext<ElectionPageParams>
): Promise<GetServerSidePropsResult<BaseElectionTemplateProps>> {
  const raceUrlSlug = "state-houses-of-assembly"
  const race = URL_SLUG_TO_RACE_HASH_MAP[raceUrlSlug]

  try {
    const getElectionPropsUsecase = new GetElectionPropsUsecase()
    const props = await getElectionPropsUsecase.execute(
      raceUrlSlug,
      context.params?.state,
      raceIsRepresentative(race) ? "constituency_code" : "state_code",
      context.params?.year
    )

    if (props.electionIndex === -1) {
      return {
        notFound: true
      }
    }

    return {
      props
    }
  } catch (error) {
    Sentry.captureException(error)
    return {
      notFound: true
    }
  }
}

export default RaceSummary
